<template>
  <v-container class="py-10 px-10" fluid>
    <v-item-group>
      <v-container fluid>
        <v-row>
          <v-col sm="12"><h1 class="font-weight-thin">Admin Home</h1></v-col>
        </v-row>
        <v-divider class="mt-5 mb-8"></v-divider>
        <v-row>
          <v-col v-for="item in filteredMenuItems" :key="item.name" cols="12" fill-height md="6" lg="3">
            <v-item v-slot:default="{ active }">
              <v-card
                :data-cy="`${item.name}-openBtn`"
                :color="active ? 'primary' : ''"
                @click="navigate(item.name)"
                class="elevation-0 och-card--tile"
                height="100%"
              >
                <v-card-text class="px-12">
                  <div class="text-center">
                    <v-icon large color="primary">{{ item.icon }}</v-icon>
                  </div>
                  <div class="display-1 text-center mt-3 primary--text">
                    {{ item.title }}
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div class="grey--text text--darken-3">
                    {{ item.description }}
                  </div>
                </v-card-text>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    filteredMenuItems() {
      const filteredItems = this.menuItems.filter(item => {
        if (!!item.hasFlag) {
          return this[item.flag] && this[item.permission];
        }

        return this[item.permission];
      });
      return filteredItems;
    },
    memberTaggingFlag() {
      return this.flagMap.memberTagging;
    },
    ...mapGetters({
      flagMap: "featureFlag/getFlagMap",
      hasAdminOchin: "session/hasAdminOchin",
      hasAdminAny: "session/hasAdminAny",
      hasAdminOrganization: "session/hasAdminOrganization",
    }),
  },
  methods: {
    navigate(name) {
      this.$router.push({ name });
    },
  },
  name: "adminMenu",
  props: {
    menuItems: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
.och-card--tile {
  border: 2px solid var(--v-accent-darken2) !important;
  border-radius: 20px !important;
}
</style>
